import { render, staticRenderFns } from "./AppItemImages.vue?vue&type=template&id=0fd4dc2f&scoped=true&"
import script from "./AppItemImages.vue?vue&type=script&lang=ts&"
export * from "./AppItemImages.vue?vue&type=script&lang=ts&"
import style0 from "./AppItemImages.vue?vue&type=style&index=0&id=0fd4dc2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd4dc2f",
  null
  
)

export default component.exports